module.exports = __webpack_public_path__ + "img/maple-mustard-grilled-chicken.f795ea1e.jpg";